import OrderCargoOrderDetailsHandlingLogRequest from "../../../../api/raily/order/cargo-order/handling-log/order-cargo-order-details-handling-log.request";
import OrderCargoOrderDetailsHandlingLogParams from "./order-cargo-order-details-handling-log-params";

const create = (
  params: OrderCargoOrderDetailsHandlingLogParams,
): OrderCargoOrderDetailsHandlingLogRequest => {
  return {
    orderId: params.orderId,
    creationStart: params.creationStart,
    creationEnd: params.creationEnd,
  };
};

const orderCargoOrderDetailsHandlingLogParamsFactory = {
  create,
};

export default orderCargoOrderDetailsHandlingLogParamsFactory;
